import { useQuery } from 'react-query';
import { AlumnoType, UserType } from '../types/types';
import hash from 'object-hash';

const baseRoute = process.env.REACT_APP_BASE_URL;


export type AddAsistenciaParams = { id?:string, dia?:string, asistencia?:'presente' | 'ausente' | 'sin-clases' | null, obs?: string };

async function asistenciaApiCall(params?: AddAsistenciaParams | null, user?:UserType | null ) {
  if (!user?.token) return null;
  if (params === null || !params?.id || !params.dia) return null;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/alumnos/asistencia`,
    { headers,
      body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as AlumnoType;
}

export function useAddAsistencia(params?:AddAsistenciaParams | null, user?:UserType | null) {
  return useQuery<AlumnoType | null, Error>(
    ['addAsistencia', hash(params ?? ''), , hash(user ?? '')],
    () => asistenciaApiCall(params, user), {
      cacheTime: 3600,
    },
  );
}

export function useEditAsistenciaManual(params?:AddAsistenciaParams | null, user?:UserType | null) {
  return useQuery<AlumnoType | null, Error>(
    ['addAsistencia', hash(params ?? ''), , hash(user ?? '')],
    () => asistenciaApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  );
}